import { PureComponent } from 'react'

import APP from 'app'

import Footer from '../../components/layout/Footer'

import './Site404.css'

class Site404 extends PureComponent {
  render() {
    return (
      <div>
        <div className="Home404__banner">
          <img
            alt="Ahora los amateurs somos las estrellas."
            className="Home404__banner_image"
            src={`${APP.url}/img/banner_01.jpg`}
          />
          <div className="Home404__banner_text">
            <br />
            <h2>Página no encontrada.</h2>
            <h4>El link que estás siguiendo no existe o fue removido.</h4>
          </div>
        </div>
        <Footer />
      </div>
    )
  }
}

export default Site404
